import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, MessageCircle } from "lucide-react";

const WHATSAPP_LINK = "https://wa.me/33643693688?text=Bonjour%2C%20je%20souhaite%20un%20devis%20pour%20une%20enseigne.";

export function Footer() {
  return (
    <footer className="py-16 px-4 sm:px-6 lg:px-8 border-t border-[#1a1a1a] bg-[#050505]" data-testid="footer">
      <div className="max-w-7xl mx-auto">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-3 h-3 rounded-full bg-[#00FF66] shadow-[0_0_10px_rgba(0,255,102,0.6)]" />
              <span className="font-['Clash_Display',sans-serif] text-xl font-bold text-white tracking-tight">PUB PRO</span>
            </div>
            <p className="text-zinc-500 text-sm leading-relaxed font-['Outfit',sans-serif]">
              Fabricant et installateur d'enseignes lumineuses en Île-de-France. Plus de 500 commerces équipés depuis 10 ans.
            </p>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-bold text-sm uppercase tracking-wider mb-4 font-['Outfit',sans-serif]">Services</h3>
            <div className="space-y-2.5">
              <a href="#services" className="block text-zinc-500 hover:text-[#00FF66] text-sm transition-colors">Enseignes lumineuses LED</a>
              <a href="#services" className="block text-zinc-500 hover:text-[#00FF66] text-sm transition-colors">Caissons lumineux</a>
              <a href="#services" className="block text-zinc-500 hover:text-[#00FF66] text-sm transition-colors">Lettres relief & boîtier</a>
              <a href="#services" className="block text-zinc-500 hover:text-[#00FF66] text-sm transition-colors">Totems & pylônes</a>
              <a href="#services" className="block text-zinc-500 hover:text-[#00FF66] text-sm transition-colors">Habillage vitrine</a>
            </div>
          </div>

          {/* Links */}
          <div>
            <h3 className="text-white font-bold text-sm uppercase tracking-wider mb-4 font-['Outfit',sans-serif]">Liens utiles</h3>
            <div className="space-y-2.5">
              <a href="#realisations" className="block text-zinc-500 hover:text-[#00FF66] text-sm transition-colors">Nos réalisations</a>
              <a href="#tarifs" className="block text-zinc-500 hover:text-[#00FF66] text-sm transition-colors">Nos tarifs</a>
              <a href="#faq" className="block text-zinc-500 hover:text-[#00FF66] text-sm transition-colors">FAQ</a>
              <Link to="/blog" className="block text-zinc-500 hover:text-[#00FF66] text-sm transition-colors" data-testid="footer-blog-link">Blog & Conseils</Link>
              <Link to="/mentions-legales" className="block text-zinc-500 hover:text-[#00FF66] text-sm transition-colors" data-testid="footer-mentions-link">Mentions légales & CGV</Link>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-bold text-sm uppercase tracking-wider mb-4 font-['Outfit',sans-serif]">Contact</h3>
            <div className="space-y-3 text-sm">
              <a href="tel:0643693688" className="flex items-center gap-2 text-zinc-500 hover:text-[#00FF66] transition-colors">
                <Phone className="w-4 h-4" /> 06 43 69 36 88
              </a>
              <a href="mailto:pubpro.france@gmail.com" className="flex items-center gap-2 text-zinc-500 hover:text-[#00FF66] transition-colors">
                <Mail className="w-4 h-4" /> pubpro.france@gmail.com
              </a>
              <p className="flex items-center gap-2 text-zinc-500">
                <MapPin className="w-4 h-4 shrink-0" /> La Courneuve (93), Île-de-France
              </p>
              <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-[#25D366] hover:text-[#20bd5a] font-semibold transition-colors mt-1">
                <MessageCircle className="w-4 h-4" /> WhatsApp
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-[#1a1a1a] pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-zinc-600 font-['Outfit',sans-serif]">
            © 2026 PUB PRO — Enseignes Lumineuses. Tous droits réservés.
          </p>
          <a href="/admin" className="text-xs text-zinc-700 hover:text-zinc-500 transition-colors">Administration</a>
        </div>
      </div>
    </footer>
  );
}
